<template>
  <form class="report-form" @submit.prevent="checkForm">
    <div class="p-4 report-form_body">
      <h1 class="mb-3 text-center font-weight-normal title-report">
        {{ title }}
      </h1>
      <p v-if="title" class="subtitle-unsubscribe">
        {{ subtitle }}
      </p>
      <div class="wrapper-reason">
        <div class="reasons">
          <div
            v-for="item in reasonsMapped.slice(0, 3)"
            :key="`item-${item.name}`"
            class="d-flex reason"
          >
            <input
              :value="item.label"
              type="checkbox"
              :name="item.name"
              :title="item.name"
              class="report-form-checkbox"
              :checked="isSelected(item.label)"
              @change="onChange(item.label)"
            />
            <span class="newCheckboxText">
              {{ item.name }}
            </span>
          </div>
        </div>
        <div class="reasons">
          <div
            v-for="item in reasonsMapped.slice(3, 6)"
            :key="`item-${item.name}`"
            class="d-flex reason"
          >
            <input
              :value="item.label"
              type="checkbox"
              :name="item.name"
              :title="item.name"
              class="report-form-checkbox"
              :checked="isSelected(item.label)"
              @change="onChange(item.label)"
            />
            <span class="newCheckboxText">
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
      <span class="form-text font-size-xs text-danger error-help"
        >{{ errors.first('reason') }}
      </span>

      <textarea
        v-if="selectedReason !== ''"
        v-model.trim="text"
        class="textField"
        data-vv-name="text"
        :error="errors.first('text')"
        :placeholder="
          $t(
            '_web_report-placeholder',
            'Please add a comment to the selected option'
          )
        "
        :label="$t('_web_report-add-comment', 'Add comment')"
      ></textarea>
    </div>

    <div class="d-flex justify-content-center py-2 report-form_actions">
      <HeraFormBtn
        id="buttonReportCancel"
        tabindex="0"
        :label="cancelButtonText"
        class="btn-accent-simple report-form_submit button-cancel "
        @click.prevent="$emit('cancel')"
      />
      <HeraFormSubmitBtn
        id="buttonReportSend"
        tabindex="1"
        :label="confirmButtonText"
        :loading="isLoading"
        class="button-confirm"
        :disabled="selectedReason === ''"
        @click.prevent="$emit('confirm')"
      />
    </div>
  </form>
</template>

<script>
import HeraFormSubmitBtn from '@/components/form/HeraFormSubmitBtn';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import { mapActions } from 'vuex';

import isLoadingMixin from '@/mixins/isLoading';
import { emptyArray } from '@/utils/factories';
import { prop } from '@/utils/factories';

export default {
  name: 'FormReport',
  inject: ['$validator'],
  components: {
    HeraFormSubmitBtn,
    HeraFormBtn,
  },
  mixins: [isLoadingMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    subscriptionID: {
      type: String,
      default: '',
    },

    cancel: prop(String),
    reasons: {
      type: Array,
      default: emptyArray,
    },
  },

  data() {
    return {
      text: '',
      selectedReason: '',
    };
  },
  computed: {
    reasonsMapped() {
      return this.reasons.map((reason, index) => {
        return {
          name: reason,
          label: index + 1,
        };
      });
    },
  },

  methods: {
    ...mapActions(['errorNotify', 'closeModal', 'sendFeedbackUnsubscribe']),
    resetErrors() {
      this.$validator.reset();
    },
    resetFields() {
      this.text = '';
      this.reason = '';
    },
    resetForm() {
      this.resetErrors();
      this.resetFields();
    },
    cancelForm() {
      this.resetForm();
      this.$emit('closeModal');
    },
    emitError(error) {
      this.errorNotify(error);
      this.$emit('error');
    },
    handleSend() {
      this.sendFeedbackUnsubscribe({
        subscriptionId: this.subscriptionID,
        reason: this.text,
        cancelation_reason: this.selectedReason,
      });
    },

    isSelected(reason) {
      return this.selectedReason === reason;
    },

    onChange(value) {
      if (this.isSelected(value)) {
        this.selectedReason = '';
      } else {
        this.selectedReason = value;
      }
    },
    checkForm() {
      if (!this.errors.count()) {
        this.setLoading();
        this.$validator
          .validateAll()
          .then(result => {
            if (result) {
              this.handleSend();
            } else {
              throw new Error(
                this.$t('_web_form-validation-error', 'Validation failed')
              );
            }
          })
          .then(this.resetForm)
          .catch(this.emitError)
          .finally(this.unsetLoading, this.$emit('confirm'));
      }
    },
  },
};
</script>

<style lang="scss">
.report-form {
  background: transparent;

  min-width: 250px;
  &_variant {
    @include auto-rtl(margin-right, 1rem);
  }

  &_actions {
    background: transparent;
    @include auto-rtl(padding-right, 1.5rem);
    @include auto-rtl(padding-left, 0.5rem);
  }

  &_submit {
    min-width: 6em;
  }
}
.reasons {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
.reason {
  display: flex;
  justify-content: flex-start;
}
.wrapper-reason {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
  @media (max-width: 470px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.5rem;
    align-items: flex-start;
  }
}
.title-report {
  font-size: 16px !important;
  line-height: 24px !important;
  font-weight: 400 !important;
  color: #eff0f1;
  margin-bottom: 48px !important;
}
.subtitle-unsubscribe {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  text-align: center;
}
.report-form-checkbox {
  border: 1px solid #49536f !important;
  margin-left: 0.5rem;
}
.button-confirm {
  color: #9d9cf7 !important;
  font-weight: 400 !important;
}
.button-cancel {
  border-radius: 4px !important;
  font-weight: 400 !important;
  height: 36px !important;
}
.textField {
  width: 100%;
  height: 80px;
  background-color: transparent;
  border-radius: 4px;
  resize: none;
  border-color: #49536f;
  padding: 10px;
  color: white;
}
</style>
